export default __webpack_public_path__ + "static/media/Dev.49f84446.png";